import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Paper from "@mui/material/Paper";
import {Stack} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {DoubleArrowOutlined} from "@mui/icons-material";

function DashboardCard(props) {
    return (
        <Paper
            sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 110,
            }}
        >
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                <div>
                    <Typography>{props.title}</Typography>
                    <Typography component="p" variant="h4">
                        {props.description}
                    </Typography>
                </div>
                <IconButton><DoubleArrowOutlined/></IconButton>
            </Stack>
        </Paper>
    );
}

DashboardCard.propTypes = {
    children: PropTypes.node,
};

export default DashboardCard;